<order-translations></order-translations>
<div class="row content-container">
	<div class="col-12 col-sm-12 main-content mynovi mynovi--order-detail">
		<div class="button-bar button-bar--justify">
			@if (!showBarcode) {
				<a (click)="setOrderAsActiveOrder()" [routerLink]="['/my/pending/orders']">
					<strong>
						<svg class="icon-arrow-left" height="10" viewBox="0 0 6 10" width="6">
							<use xlink:href="/images/icons/svg-sprite.svg#arrow-left"></use>
						</svg>
						<span i18n="Back to products link text@@back.to.all.orders">
                            Back to all orders
                        </span>
					</strong>
				</a>
			}

			@if (showBarcode) {
				<a (click)="showBarcode = false">
					<strong>
						<svg class="icon-arrow-left" height="10" viewBox="0 0 6 10" width="6">
							<use xlink:href="/images/icons/svg-sprite.svg#arrow-left"></use>
						</svg>
						<span i18n="Back to order@@back.to.order"> Back to order </span>
					</strong>
				</a>
			}
		</div>

		<!-- <span>'s binnen de h1 zorgen ervoor dat de datum en locatie los van elkaar op een nieuwe regel breken als het scherm kleiner wordt -->
		@if (!showBarcode) {
			<h1 class="order-detail-title">
				@if (shipmentDate) {
					<span>{{ shipmentDate | customDate: "EEEE dd MMMM" }}</span>
				}
				-
				@if (deliveryAddress) {
					<span data-private>{{ deliveryAddress.name }}</span>
				}
			</h1>
		}

		@if (showBarcode) {
			<h1 i18n="@@add.barcodes">Add barcodes</h1>
			<p>&nbsp;</p>
			<!-- <span>'s binnen de h3 zorgen ervoor dat de datum en locatie los van elkaar op een nieuwe regel breken als het scherm kleiner wordt -->
			<h4 class="order-detail-title">
				@if (shipmentDate) {
					<span>{{ shipmentDate | customDate: "EEEE dd MMMM" }}</span>
				}
				-
				@if (deliveryAddress) {
					<span data-private>{{ deliveryAddress.name }}</span>
				}
			</h4>
		}

		@if (!showBarcode) {
			<div class="order-detail-info">
				@if (shipmentDate) {
					<dl>
						<dt i18n="pending order detail: shipping date@@shipping.date">
							Shipping date
						</dt>
						<dd>{{ shipmentDate | customDate: "EEE dd MMM yy" }}</dd>
					</dl>
				}

				@if (deliveryDate) {
					<dl>
						<dt i18n="pending order detail: Delivery date@@delivery.date">
							Delivery date
						</dt>
						<dd>{{ deliveryDate | customDate: "EEE dd MMM yy" }}</dd>
					</dl>
				}

				<dl>
					<dt i18n="pending order detail: Shipping destination@@shipping.destination">
						Shipping destination
					</dt>
					@if (deliveryAddress) {
						<dd data-private>{{ deliveryAddress.name }}</dd>
					}
				</dl>

				@if (closingInHours > 0) {
					<dl>
						<dt i18n="pending order detail: order 'closes in'@@order.closes">
							Closes
						</dt>
						<dd>{{ closingTimeString }}</dd>
					</dl>
				}

				<dl>
					<dt i18n="pending order detail: total volume@@shipping.total.volume">
						Total volume
					</dt>
					<dd i18n="Calculated volume (CC)@@calculated.volume">
						{{ totalVolume | numberFormat: false }} CC
					</dd>
				</dl>

				<dl>
					<dt i18n="order detail: total volume cut@@shipping.volume.cut">
						Volume cut
					</dt>
					<dd i18n="Calculated volume (CC)@@calculated.volume">
						{{ totalVolumeCut | numberFormat: false }} CC
					</dd>
				</dl>

				<dl>
					<dt i18n="order detail: total volume plants@@shipping.volume.plants">
						Volume plants
					</dt>
					<dd i18n="Calculated volume (CC)@@calculated.volume">
						{{ totalVolumePlants | numberFormat: false }} CC
					</dd>
				</dl>

				<dl>
					<dt i18n="order detail: total volume misc@@shipping.volume.misc">
						Volume misc
					</dt>
					<dd i18n="Calculated volume (CC)@@calculated.volume">
						{{ totalVolumeMisc | numberFormat: false }} CC
					</dd>
				</dl>

				@if (getCustomerNoReference() != null) {
					<dl>
						<dt i18n="order detail: customer reference@@customer.reference.label">
							Your reference
						</dt>
						<dd>{{ getCustomerNoReference() }}</dd>
					</dl>
				}
			</div>
		}

		@if (!showBarcode) {
			<div class="order-detail-actions">
				@if (isBarcodeEnabled) {
					<a (click)="addBarcodeView()">
                        <span class="order-detail-actions_icon">
                            <svg class="icon-barcode" height="10" width="16">
                                <use xlink:href="/images/icons/svg-sprite.svg#barcode"></use>
                            </svg>
                        </span>
						<span i18n="Add barcodes link@@add.barcodes">Add barcodes</span>
					</a>
				}
			</div>
		}

		@if (showAddProducts()) {
			<div class="button-bar button-bar--justify button-bar--va-bottom button-bar--mobile-block">
				<div class="text-center" sales-person-telephone></div>
				<div class="button-bar--action-buttons">
					@if (isConfirmAllEnabled()) {
						<button (click)="confirmAll()"
						        [disabled]="confirmAllLoading"
						        class="button theme-btn-primary"
						        i18n="Confirm order button@@confirm.order"
						        type="button">
							Confirm order
						</button>
					}

					<button (click)="handleAddProducts()"
					        [disabled]="!addProductsAllowed()"
					        class="button theme-btn-success"
					        i18n="Add products link@@add.products"
					        type="button">
						Add products
					</button>
				</div>
			</div>
		}

		@if (showBarcode) {
			<div class="button-bar button-bar--justify button-bar--va-bottom">
				<div class="text-center">&nbsp;</div>
				<a (click)="confirmBarcodes()"
				   class="button theme-btn-primary"
				   i18n="Confirm barcodes link@@confirm.barcodes">
					Confirm barcodes
				</a>
			</div>
		}

		<div class="grid-container grid-table-filter-bar table-filter-bar">
			<div class="grid-item">
				@if (showBarcode) {
					<form class="grid-container grid-custom-6 factorForm">
						<label [for]="factorForm.controls['factor']" i18n="Barcode: factor@@barcode.factor">
							Factor
						</label>

						<input [formControl]="factorForm.controls['factor']"
						       pattern="[0-9]*[.,]?[0-9]+"
						       type="text"
						       value="1.00" />

						<label [for]="factorForm.controls['rounding']" i18n="Barcode: Rounding@@barcode.rounding">
							Rounding
						</label>

						<div class="custom-select">
							<select [formControl]="factorForm.controls['rounding']">
								<option>0.01</option>
								<option>0.02</option>
								<option>0.05</option>
								<option>0.09</option>
								<option>0.10</option>
								<option>0.25</option>
								<option>0.50</option>
								<option>0.80</option>
								<option>0.90</option>
								<option>0.95</option>
								<option>0.99</option>
								<option>1.00</option>
								<option>9.00</option>
							</select>
						</div>

						<button
								(click)="updateBarcodeSalesPrices()"
								class="button button--small theme-btn-primary"
								i18n="Update barcode button label@@update.barcode.button"
								type="button">
							Update
						</button>
					</form>
				}
			</div>
			<div class="grid-item" [ngClass]="{ 'align-right': !showBarcode }">
				<form class="sortOnForm overview-sort">
					<label i18n="Barcode view: Sort on@@barcode.sort.on">Sort on:</label>
					<pending-order-detail-sort
							(sortChangeEvent)="onSortOrderChange($event)"
							i18n-labelSortDescription="@@sort.on.description"
							i18n-labelSortInserted="@@barcode.sort.on.inserted"
							i18n-labelSortPrice="@@sort.on.price"
							i18n-labelSortQuantity="@@barcode.sort.on.amount.unit"
							i18n-labelSortVolume="@@barcode.sort.on.volume"
							i18n-labelSortWithoutBarcode="@@barcode.sort.on.without.barcode"
							activeSortFieldKeyAndOrder="inserted|ASC"
							labelSortDescription="Description"
							labelSortInserted="Inserted"
							labelSortPrice="Price"
							labelSortQuantity="Amount unit"
							labelSortVolume="Volume"
							labelSortWithoutBarcode="Without barcode">

					</pending-order-detail-sort>
				</form>
			</div>
		</div>

		<table class="order-overview-table order-overview-table--pending-detail">
			<thead>
				<tr>
					<th colspan="4" i18n="pending order detail: product header@@order.product.header" scope="col">
						Product
					</th>

					<th i18n="pending order detail: amount header@@order.amount" scope="col">
						Amount
					</th>

					<th i18n="pending order detail: pot size@@order.potsize" scope="col">
						Pot size
					</th>

					<th i18n="pending order detail: height@@order.height" scope="col">
						Height
					</th>

					<th i18n="pending order detail: volume header@@order.volume" scope="col">
						Volume
					</th>

					<th i18n="pending order detail: price header@@order.price" scope="col">
						Price
					</th>

					<th colspan="2"></th>
				</tr>
			</thead>

			@for (line of shoppingCartLines; track trackByFunction(index, line); let index = $index) {
				<tbody>
					<tr [allowComment]="allowComments"
					    [closingTime]="closingInHours"
					    [shoppingCartLine]="line"
					    [showBarcode]="showBarcode"
					    shopping-cart-row>
					</tr>

					@if (showBarcode) {
						<tr #addbarcode
						    (addBarCode)="addBarcode($event, line)"
						    [shoppingCartLine]="line"
						    add-barcode-row
						    class="add-barcode-row">
						</tr>
					}
				</tbody>
			}

			@if (!showBarcode) {
				<tfoot>
					<tr>
						<td class="order-overview-table_footer-total--label"
						    colspan="7"
						    i18n="pending order detail : total@@order.detail.total">
							Total:
						</td>

						<td class="order-overview-table_footer-total--volume"
						    i18n="Calculated volume (CC)@@calculated.volume">
							{{ totalVolume | numberFormat: false }} CC
						</td>

						@if (showBarcode) {
							<td class="order-overview-table_footer-total--volume">
								&nbsp;
							</td>
						}

						<td class="order-overview-table_footer-total--price" colspan="3">
							{{ applicationService.getUserCurrency() }}
							{{ totalPrice | numberFormat: true }}
						</td>
					</tr>
				</tfoot>
			}
		</table>

		<div class="grid-container grid-2 grid-1-mobile mt-6">
			<div class="grid-item">
				@if (isCustomerReferenceEnabled()) {
					<div class="button-bar button-bar--left button-bar--mobile-block button-bar--reference">
						<input [formControl]="referenceForm.controls['reference']"
						       placeholder="Referentie"
						       type="text" />

						<button (click)="submitReference()"
						        class="button theme-btn-primary order-overview_button--add-reference"
						        i18n="Add reference button@@add.reference.button"
						        type="button">
							Add
						</button>
					</div>
				}
			</div>
			<div class="grid-item align-right">
				@if (isConfirmAllEnabled()) {
					<button (click)="confirmAll()"
					        [disabled]="confirmAllLoading"
					        class="button theme-btn-primary"
					        i18n="Confirm order button@@confirm.order"
					        type="button">
						Confirm order
					</button>
				}

				<button (click)="handleAddProducts()"
				        [disabled]="!showAddProducts() || !addProductsAllowed()"
				        class="button theme-btn-success"
				        i18n="Add products link@@add.products"
				        type="button">
					Add products
				</button>

				@if (showBarcode) {
					<a (click)="confirmBarcodes()"
					   class="button theme-btn-primary"
					   i18n="Confirm barcodes link@@confirm.barcodes">
						Confirm barcodes
					</a>
				}
			</div>
		</div>

		<ng-template modal-wrapper></ng-template>
	</div>
</div>
